import Link from 'next/link'
import clsx from 'clsx'

const MenuLink = ({children, href, className, onClick}: any) => {
  return (
    <Link
      href={href}
      className={clsx(
        'rounded-lg text-gray-900 font-medium opacity-60 p-2 hover:bg-gray-100 hover:opacity-100',
        className
      )}
      onClick={onClick}>
      {children}
    </Link>
  )
}

export default MenuLink
